/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Common_Notavailable2Inputs */

const id_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak tersedia`)
};

const ms_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak tersedia`)
};

const da_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke tilgængelig`)
};

const de_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht verfügbar`)
};

const en_us2_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not available`)
};

const es_es2_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No disponible`)
};

const es_mx2_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No disponible`)
};

const fil_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi available`)
};

const fr_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non disponible`)
};

const it_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non disponibile`)
};

const hu_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem elérhető`)
};

const nl_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet beschikbaar`)
};

const no_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke tilgjengelig`)
};

const pl_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedostępne`)
};

const pt_br2_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não disponível`)
};

const pt_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não disponível`)
};

const ro_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indisponibil`)
};

const fi_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei saatavilla`)
};

const sv_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inte tillgänglig`)
};

const vi_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không khả dụng`)
};

const tr_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanılamıyor`)
};

const cs_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Není k dispozici`)
};

const bg_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не е налично`)
};

const ru_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недоступно`)
};

const uk_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недоступно`)
};

const ar_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير متوفر`)
};

const hi_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्ध नहीं`)
};

const th_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พร้อมใช้งาน`)
};

const ja_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用不可`)
};

const zh_cn2_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不可用`)
};

const zh_hant1_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法使用`)
};

const ko_offerdetail_common_notavailable2 = /** @type {(inputs: Offerdetail_Common_Notavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용할 수 없음`)
};

/**
* | output |
* | --- |
* | "Not available" |
*
* @param {Offerdetail_Common_Notavailable2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_common_notavailable2 = /** @type {((inputs?: Offerdetail_Common_Notavailable2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Common_Notavailable2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_common_notavailable2(inputs)
	if (locale === "ms") return ms_offerdetail_common_notavailable2(inputs)
	if (locale === "da") return da_offerdetail_common_notavailable2(inputs)
	if (locale === "de") return de_offerdetail_common_notavailable2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_common_notavailable2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_common_notavailable2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_common_notavailable2(inputs)
	if (locale === "fil") return fil_offerdetail_common_notavailable2(inputs)
	if (locale === "fr") return fr_offerdetail_common_notavailable2(inputs)
	if (locale === "it") return it_offerdetail_common_notavailable2(inputs)
	if (locale === "hu") return hu_offerdetail_common_notavailable2(inputs)
	if (locale === "nl") return nl_offerdetail_common_notavailable2(inputs)
	if (locale === "no") return no_offerdetail_common_notavailable2(inputs)
	if (locale === "pl") return pl_offerdetail_common_notavailable2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_common_notavailable2(inputs)
	if (locale === "pt") return pt_offerdetail_common_notavailable2(inputs)
	if (locale === "ro") return ro_offerdetail_common_notavailable2(inputs)
	if (locale === "fi") return fi_offerdetail_common_notavailable2(inputs)
	if (locale === "sv") return sv_offerdetail_common_notavailable2(inputs)
	if (locale === "vi") return vi_offerdetail_common_notavailable2(inputs)
	if (locale === "tr") return tr_offerdetail_common_notavailable2(inputs)
	if (locale === "cs") return cs_offerdetail_common_notavailable2(inputs)
	if (locale === "bg") return bg_offerdetail_common_notavailable2(inputs)
	if (locale === "ru") return ru_offerdetail_common_notavailable2(inputs)
	if (locale === "uk") return uk_offerdetail_common_notavailable2(inputs)
	if (locale === "ar") return ar_offerdetail_common_notavailable2(inputs)
	if (locale === "hi") return hi_offerdetail_common_notavailable2(inputs)
	if (locale === "th") return th_offerdetail_common_notavailable2(inputs)
	if (locale === "ja") return ja_offerdetail_common_notavailable2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_common_notavailable2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_common_notavailable2(inputs)
	return ko_offerdetail_common_notavailable2(inputs)
});
export { offerdetail_common_notavailable2 as "offerDetail.common.notAvailable" }